<template>
  <div class="edit-address">
    <van-form
        ref="form"
        label-align="center"
        @submit="saveAddress"
    >
      <van-field
          v-model="addresseeName"
          label="收货人"
          placeholder="请输入收件人姓名"
          :rules="[{required: true, message: '必填'}]"
      ></van-field>
      <van-field
          v-model="addresseeTel"
          clearable
          type="number"
          maxLength="16"
          label="电话"
          placeholder="请输入手机号码"
          :rules="[{required: true, message: '必填'}]"
      >
      </van-field>
      <div class="area-text-con">
        <van-field
            v-model="showAreaText"
            readonly
            label="地区"
            placeholder="请选择收货地址"
            :rules="[{required: true, message: '必填'}]"
        ></van-field>
        <div class="showArea-click-con" @click="showArea=true">
          <span class="icon"></span>
        </div>
      </div>
      <van-field
          v-model="detailAddress"
          rows="3"
          type="textarea"
          maxlength="100"
          show-word-limit
          label="详细地址"
          placeholder="如道路、门牌号、小区、楼栋号、单元室等"
          :rules="[{required: true, message: '必填'}]"
      >
      </van-field>

      <div class="bg-10px"></div>
      <van-field name="switch" label="设为默认地址" input-align="right">
        <template #input>
          <van-switch v-model="isDefault" size="21.5" />
        </template>
      </van-field>

      <div class="btn-con" style="padding: 20px;">
        <van-button round block type="info" native-type="submit">保存</van-button>
      </div>

    </van-form>

    <sg-area :show="showArea" :editArea="editArea" @onChange="onChange" @onClose="onClose" />
  </div>
</template>

<script>
import { addressAdd, addressDetail, addressEdit } from '@/api/mall/mallLogistics'
import sgArea from '@/components/sgArea'
export default {
  components: {
    sgArea,
  },
  data(){
    return {
      addresseeName: '',//收货人姓名
      addresseeTel: '',//收货人手机
      showAreaText: '',//显示的区域
      detailAddress: '',//收货人详细地址
      isDefault: false,//是否默认地址
      countryAreaId: 0,//国家级平台行政区划ID
      provinceAreaId: 0,//省级平台行政区划ID
      cityAreaId: 0,//市级平台行政区划ID
      countyAreaId: 0,//区/县级平台行政区划ID
      townAreaId: 0,//街道/镇级平台行政区划ID

      showArea: false,// 三级联动弹窗

      editArea: {},//接口返回的区域Id

    }
  },
  created() {
    if(this.$route.query.userAddressId){
      this.getAddressDetail()
    }
  },
  methods:{
    getAddressDetail(){
      addressDetail({ userAddressId: this.$route.query.userAddressId }).then(res=>{
        if(res.data){
          this.addresseeName = res.data.addresseeName
          this.addresseeTel = res.data.addresseeTel
          this.countryAreaId = res.data.countryAreaId
          this.provinceAreaId = res.data.provinceAreaId
          this.cityAreaId = res.data.cityAreaId
          this.countyAreaId = res.data.countyAreaId
          this.townAreaId = res.data.townAreaId
          this.detailAddress = res.data.detailAddress
          this.isDefault = res.data.isDefault
          this.showAreaText = res.data.fullArea

          this.editArea = {
            countryAreaId: res.data.countryAreaId,
            provinceAreaId: res.data.provinceAreaId,
            cityAreaId: res.data.cityAreaId,
            countyAreaId: res.data.countyAreaId,
            townAreaId: res.data.townAreaId,
          }
        }
      })
    },

    //区域显示文字
    onChange(text){
      if(text){
        this.showAreaText = text
      }
    },
    onClose(data){
      this.showArea = false;
      this.provinceAreaId = data.area1 ? data.area1.areaId : 0;
      this.cityAreaId = data.area2 ? data.area2.areaId : 0;
      this.countyAreaId = data.area3 ? data.area3.areaId : 0;
      this.townAreaId = data.area4 ? data.area4.areaId : 0;
      // console.log(data)
      console.log('省:%d, 市:%d, 县:%d, 街道:%d', this.provinceAreaId, this.cityAreaId, this.countyAreaId, this.townAreaId )
    },

    // 保存
    saveAddress(){
      this.$refs['form'].validate().then(()=>{
        let req = {
          addresseeName: this.addresseeName,
          addresseeTel: this.addresseeTel,
          detailAddress: this.detailAddress,
          isDefault: this.isDefault,
          countryAreaId: this.countryAreaId,
          provinceAreaId: this.provinceAreaId,
          cityAreaId: this.cityAreaId,
          countyAreaId: this.countyAreaId,
          townAreaId: this.townAreaId,
        };
        if(this.$route.query.userAddressId){ //编辑
          req.userAddressId = this.$route.query.userAddressId
          console.log(req)
          addressEdit(req).then(res=>{
            if(res.code===200){
              this.$store.dispatch('my/getAddressList', {openid: this.session('userOpenId')})
              this.$toast('修改成功！')
              window.setTimeout(()=>{
                this.$router.go(-1)
              },1000)
            }else {
              this.$toast(res.message)
            }
          })
        }else { // 新增
          console.log(req)
          addressAdd(req).then(res=>{
            if(res.code===200){
              this.$store.dispatch('my/getAddressList', {openid: this.session('userOpenId')})
              this.$toast('添加成功！')
              window.setTimeout(()=>{
                this.$router.go(-1)
              },1000)
            }else {
              this.$toast(res.message)
            }
          })
        }
      })
    }

  }
}
</script>

<style lang="less" scoped>
.edit-address{
  position: relative;width: 100%;height: 100%;
  background-color: #f5f5f5;padding-top: 10px;font-size: 14px;

  .area-text-con{
    position: relative;
    .showArea-click-con{
      position: absolute;z-index: 1;top: 0;bottom: 0;left: 0;right: 0;
      display: inline-flex;justify-content: flex-end;align-items: center;
      .icon{
        display: inline-flex;width: 12px;height: 19px;margin-right: 16px;
        background: url("../../../assets/my/icon-right.png") no-repeat 50% 50%;
        background-size: 100%;
      }
    }
  }
}
</style>